import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../store/app-state";
import { MainContent } from "./company-profile.styled";
import CompanySection from "./components/company-section/company-section";
import GroupSection from "./components/group-section/group-section";
import { getUser } from "../../../store/auth/auth-actions";
import Modal from "../../../components/modal/modal";
import AddPeopleModal from "./components/group-section/components/add-people-modal/add-people-modal";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../../../components/home-components/header/header";
import { useQuery } from "../../../hooks";

const modalTalent = document.getElementById("modal-talent");

interface QueryInterface {
  invite_email?: string;
}
const CompanyProfile: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [query, setQuery] = useQuery<QueryInterface>();
  const { token, user } = useSelector((state: AppState) => state.authState);
  const [showAddPeopleModal, setShowAddPeopleModal] = useState<boolean>(false);
  const { t } = useTranslation("private-home-page");
  const [initialEmail, setInitialEmail] = useState<string>("");

  const treatInviteEmail = useCallback((email: string): string => {
    const decoded = decodeURIComponent(email);
    return decoded.split('@')[0];
  }, []);

  useEffect(() => {
    if (query.invite_email) {
      setInitialEmail(treatInviteEmail(query.invite_email));
      setShowAddPeopleModal(true);
      setQuery({});
    }
  }, [query.invite_email, setQuery, treatInviteEmail]);
  
  useEffect(() => {
    if (token) {
      dispatch(getUser());
    }
  }, [token, dispatch]);

  useEffect(() => {
    if (user && !user.is_talent_admin) {
      history.push("/home");
    }
  }, [user, history]);

  return (
    <MainContent>
      <Modal
        target={modalTalent}
        toggle={() => setShowAddPeopleModal(!showAddPeopleModal)}
        isShown={showAddPeopleModal}
        width={510}
      >
        <AddPeopleModal initial_email={initialEmail} />
      </Modal>
      <Header isSelecteds={true} title={t('company-profile.title')} />
      <CompanySection />
      <GroupSection
        onClickAdd={() => setShowAddPeopleModal(!showAddPeopleModal)}
      />
      <div id="separator" style={{ height: "5rem" }} />
    </MainContent>
  );
};

export default CompanyProfile;
